import React from 'react'
import styled from 'styled-components'
import TokenLogo from '../TokenLogo'
import { isNRGTokenAddress } from '../../utils'

export default function DoubleTokenLogo({ a0, a1, size = 24, margin = false, firstNRG = true }) {
  const TokenWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    margin-right: ${({ sizeraw, margin }) => margin && (sizeraw / 3 + 12).toString() + 'px'};
  `

  const HigherLogo = styled(TokenLogo)`
    z-index: 2;
    border-radius: 50%;
  `

  const CoveredLogo = styled(TokenLogo)`
    position: absolute;
    left: ${({ sizeraw }) => (sizeraw / 2 + 4).toString() + 'px'};
    border-radius: 50%;
  `

  let tempA
  if (isNRGTokenAddress(a1) && firstNRG) {
    tempA = a1
    a1 = a0
    a0 = tempA
  }

  return (
    <TokenWrapper sizeraw={size} margin={margin}>
      <HigherLogo address={a0} size={size.toString() + 'px'} sizeraw={size} />
      <CoveredLogo address={a1} size={size.toString() + 'px'} sizeraw={size} />
    </TokenWrapper>
  )
}
